import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateApprovalGuide } from '../api';

const APPROVAL_GUIDE_QUERY_KEY = 'approvalGuide';

/**
 * useApprovalGuideMutation 훅
 * 결재라인 가이드 정보를 업데이트하는 React Query Mutation 훅
 * @param {object} options - React Query의 useMutation 훅에 전달할 옵션
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
export function useApprovalGuideMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateApprovalGuide,
    onSuccess: function () {
      // 성공 시 캐시 무효화하여 최신 데이터 다시 조회
      queryClient.invalidateQueries({ queryKey: [APPROVAL_GUIDE_QUERY_KEY] });
    },
    ...options,
  });
}
